<div class='RegisterComponent'>
  <h1 class='text-center'>Sign Up</h1>

  <div class='reg-wrapper container mt-5'>
    <div class='py-5'>
      <div class='Register_wrapper__container d-flex flex-column'>
        <div class='flex-grow-1 Register_wrapper_progressbar'>
          <span class='text-muted'>Step {{ currentStep }} of 5</span>
          <div class='progress mt-3'>
            <div
              [style.width]="(currentStep / 5) * 100 + '%'"
              class='progress-bar'
              role='progressbar'>
              {{ (currentStep / 5) * 100 }}%
            </div>
          </div>
        </div>
        <div class='flex-grow-1'>
          <app-register-step-create
            (Submit)='onStepSubmit($event)'
            *ngIf='currentStep === 1'
            [emailErrors]='emailErrors'
            [isEmailTaken]='isEmailTaken'></app-register-step-create>
          <app-register-step-pay
            (Submit)='onStepPay($event)'
            *ngIf='currentStep === 2'
            [paymentErrors]='paymentErrors'
            [preFilledPayData]='registerFormPayData'></app-register-step-pay>
          <app-register-step-pay-progress
            *ngIf='currentStep === 3'></app-register-step-pay-progress>
          <app-register-step-receipt
            (Continue)='onReceiptContinue($event)'
            *ngIf='currentStep === 4'
            [paymentData]='
              registerPaymentReceiptData
            '></app-register-step-receipt>
          <app-register-step-confirm
            (Submit)='onStepConfirm($event)'
            *ngIf='currentStep === 5'
            [confirmationErrorMessage]='confirmationErrorMessage'
            [confirmationToken]='confirmationToken'></app-register-step-confirm>
        </div>
      </div>

      <div *ngIf='currentStep !== 3' class='Register_wrapper__footer mt-5'>
        <div class='register-footer-wrapper'>
          <div
            class='register-footer-wrapper-item'
            style='background-color: #6b86c3'>
            <div class='register-footer-wrapper-item-icon'>
              <h2>1</h2>
            </div>
            <div class='register-footer-wrapper-item-title'>
              <p>I'm Ready tp Sign Up</p>
            </div>
            <div class='register-footer-wrapper-item-description'>
              <p>
                Great! You’ll be the top dog almost faster than you can say,
                “Retreva, fetch my contacts.” Using Retreva means no contracts,
                cancel any time and complete support.
              </p>
            </div>
            <div class='register-footer-wrapper-item-button'>
              <app-button
                [size]="'normal'"
                [style]="'rounded'"
                color='orange'
                route='/register'
                text='Sign Up'></app-button>
            </div>
          </div>
          <div
            class='register-footer-wrapper-item'
            style='background-color: #345d9e'>
            <div class='register-footer-wrapper-item-icon'>
              <h2>2</h2>
            </div>
            <div class='register-footer-wrapper-item-title'>
              <p>I want to watch the Demo video</p>
            </div>
            <div class='register-footer-wrapper-item-description'>
              <p>
                Watch our short explanation of how Retreva works. We know you’ll
                love it once you see it.
              </p>
            </div>
            <div class='register-footer-wrapper-item-button'>
              <app-button
                [size]="'normal'"
                [style]="'rounded'"
                color='orange'
                route='/register'
                text='Watch Video'></app-button>
            </div>
          </div>
          <div
            class='register-footer-wrapper-item'
            style='background-color: #16376b'>
            <div class='register-footer-wrapper-item-icon'>
              <h2>3</h2>
            </div>
            <div class='register-footer-wrapper-item-title'>
              <p>I want more information.</p>
            </div>
            <div class='register-footer-wrapper-item-description'>
              <p>
                We get it. We want you to be comfortable and ready to top the
                sales charts, too.
              </p>
            </div>
            <div class='register-footer-wrapper-item-button'>
              <app-button
                [size]="'normal'"
                [style]="'rounded'"
                color='orange'
                route='/register'
                text='SCHEDULE A LIVE DEMO'></app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
